module.exports = __webpack_public_path__ + "img/product21-zhihui.ee3c72f9.svg";